<template>
  <div>
    <div class="auth-callback d-flex flex-column align-items-center justify-content-center">
      <div v-if="store.isLoading" class="text-center">
        <div class="spinner-border fa-3x" role="status">
          <span class="visually-hidden">Caricamento...</span>
        </div>
         
        <p class="mt-3">Autenticazione in corso, attendere prego...</p>
      </div>

      <div v-else-if="store.authError" class="text-center">
        <i class="fas fa-exclamation-triangle fa-3x text-danger"></i>
        <h3 class="mt-3">Errore di Autenticazione</h3>
        <p>{{ store.authError }}</p>
        <button @click="goHome" class="btn btn-primary mt-2">
          <i class="fas fa-home me-1"></i>
          Torna alla Home
        </button>
      </div>
      <div v-else class="text-center">
        <i class="fas fa-check-circle fa-3x text-success"></i>
        <h3 class="mt-3">Autenticazione Riuscita!</h3>
        <div class="spinner-border fa-3x" role="status">
          <span class="visually-hidden">Caricamento dei dati...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from '../stores/app.js'
const store = useAppStore()
const router = useRouter()
const goHome = () => {
  router.push('/')
}

onMounted(async () => {


  // debugger;

  
  // Logica di callback di autenticazione verrà implementata qui
  await store.resolveCodeOAuth2();

  if(store.authError){
    console.error("Errore di autenticazione:", store.authError);
    return;
  }

  // Dopo il login, se c'era un codice invito pending torna alla JoinView
  const pendingCode = sessionStorage.getItem('poderi_pending_invite_code')
  if (pendingCode) {
    router.push(`/join/${pendingCode}`)
    return
  }

  goHome();
})



</script>


<style scoped>
.auth-callback {
  min-height: 60vh;
  display: flex;
  align-items: center;
}

.fa-3x {
  font-size: 3rem;
}
</style>